import * as Sentry from "@sentry/react";

export function setupGlobalErrorHandler() {
  window.addEventListener("unhandledrejection", (event) => {
    const error =
      event.reason instanceof Error
        ? event.reason
        : new Error(String(event.reason));
    Sentry.captureException(error);
  });

  window.addEventListener("error", (event) => {
    const error = event.error ?? new Error(event.message);
    Sentry.captureException(error);
  });
}
